import React from "react";
import { Link } from "react-router-dom";
import {
  RiUserReceived2Line,
  RiHealthBookLine,
  RiParentLine,
  RiFundsLine,
} from "react-icons/ri";
import { BsHouse, BsBoxSeam, BsCalendar4Event } from "react-icons/bs";
import { GrStatusGoodSmall } from "react-icons/gr";
import { HiOutlineAcademicCap, HiOutlineCash } from "react-icons/hi";
import { TiGroupOutline } from "react-icons/ti";
import { FaUniversity } from "react-icons/fa";
import DashLayout from "../../layouts/DashLayout";

function Services() {
  const links = [
    {
      name: "Beneficiaries",
      icon: <RiUserReceived2Line className="text-xl ml-2" />,
      path: "/services/beneficiries",
    },
    {
      name: "Performance",
      icon: <HiOutlineAcademicCap className="text-xl ml-2" />,
      path: "/academics",
    },
    {
      name: "Insurance",
      icon: <RiHealthBookLine className="text-xl ml-2" />,
      path: "/insurances",
    },
    {
      name: "Assocciations",
      icon: <TiGroupOutline className="text-xl ml-2" />,
      path: "/assocciations",
    },
    {
      name: "Residences",
      icon: <BsHouse className="text-xl ml-2" />,
      path: "/services/residences",
    },
    {
      name: "Ubudehe category",
      icon: <HiOutlineCash className="text-xl ml-2" />,
      path: "/services/categories",
    },
    {
      name: "Stores",
      icon: <BsBoxSeam className="text-xl ml-2" />,
      path: "/services/stock",
    },
    {
      name: "Caregivers and parents",
      icon: <RiParentLine className="text-xl ml-2" />,
      path: "/services/caregivers",
    },
    {
      name: "Schools",
      icon: <FaUniversity className="text-xl ml-2" />,
      path: "/services/schools",
    },
    {
      name: "Events",
      icon: <BsCalendar4Event className="text-xl ml-2" />,
      path: "/services/events",
    },
    {
      name: "Gifts and Funds",
      icon: <RiFundsLine className="text-xl ml-2" />,
      path: "/services/funds",
    },
    {
      name: "Economy",
      icon: <GrStatusGoodSmall className="text-xl ml-2" />,
      path: "/services/economy",
    },
  ];
  return (
    <DashLayout>
      <div className="bg-white rounded mx-10">
        <div className="flex p-10 pl-10 pb-4">
          <h2 className="font-semibold">Services that you have access on</h2>
        </div>
        <div className="border-b border-gray-300 ml-10 mr-10" />
        <div className="p-5 pl-10 flex flex-wrap  w-full">
          {links.map((link, i) => {
            return (
              <Link
                className="flex flex-row  py-2 w-full md:w-1/2 lg:w-1/3 font-medium"
                key={i}
                to={link.path}
              >
                <div className="flex w-full  pr-5 bg-gray-100 hover:bg-gray-200 mr-4 rounded">
                  <div className="h-full  bg-indigo-100 text-indigo-500 py-5 px-3 flex rounded">
                    <div className="m-auto">{link.icon}</div>
                  </div>{" "}
                  <div className="m-auto ml-4">{link.name}</div>
                </div>{" "}
              </Link>
            );
          })}
        </div>
      </div>
    </DashLayout>
  );
}

export default Services;
